import React from 'react';
import PropTypes from 'prop-types';

import { DeleteIcon, StyledDeleteButton } from './DeleteButton.styled';

const DeleteButton = ({ onClick, dataTestId }) => (
  <StyledDeleteButton
    icon={<DeleteIcon />}
    data-testid={dataTestId}
    onClick={onClick}
  />
);

DeleteButton.propTypes = {
  onClick: PropTypes.func,
  dataTestId: PropTypes.string,
};

DeleteButton.defaultProps = {
  onClick: undefined,
  dataTestId: undefined,
};

export default DeleteButton;
